import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../../config/endpoints.config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrExamToppageService {

  constructor(private http: HttpClient) { }
  getInfoTopPage() {
      return this.http.post<any>(EndpointsConfig.toppage.getInfoTopPage, null);
  }
}
